import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import classnames from 'clsx';
import React from 'react';

import styles from './Title.scss';

interface Props {
  isOpen: boolean;
  children: React.ReactNode;
}

const Title: React.FC<Props> = ({ children, isOpen }) => (
  <div className={styles.titleWrapper}>
    <div className={styles.title}>{children}</div>
    <Icon
      icon={ChevronMediumDown}
      className={classnames(styles.icon, {
        [styles.iconOpen]: isOpen
      })}
      size="lg"
    />
  </div>
);

export default Title;
